import React from "react";
import PaymentMethod from "../../../../utilities/data/model/PaymentMethod";
import { FlatList } from "react-native";
import { Card, Divider, PayTypeToIcon } from "@towersystems/roam-common-native";
import { Button } from "./components";

export interface SelectablePaymentMethodButtonListProps {
  wrapped?: boolean;
  items: PaymentMethod[];
  allDisabled?: boolean;
  disabledItems?: string[];
  disabledFn?: (paymentMethod: PaymentMethod) => boolean;
  onPressAll?: (paymentMethod: PaymentMethod) => void;
}

export const SelectablePaymentMethodButtonList = ({
  wrapped = true,
  items,
  allDisabled = false,
  disabledItems = [],
  disabledFn,
  onPressAll,
}: SelectablePaymentMethodButtonListProps) => {
  const handleOnPress = React.useCallback(
    (item: PaymentMethod) => {
      onPressAll && onPressAll(item);
    },
    [onPressAll]
  );

  const onRenderItem = React.useCallback(
    ({ item }: { item: PaymentMethod }) => {
      return (
        <Button
          onPress={() => handleOnPress(item)}
          label={item.name}
          icon={<PayTypeToIcon payType={item.payType.id} />}
          disabled={
            allDisabled ||
            disabledItems.includes(item.payType.id) ||
            disabledFn?.(item) ||
            false
          }
        />
      );
    },
    [disabledFn, disabledItems, allDisabled]
  );

  const listMarkup = (
    <FlatList
      ItemSeparatorComponent={() => <Divider marginVertical={0} />}
      renderItem={onRenderItem}
      data={items}
      scrollEnabled={false}
    ></FlatList>
  );

  return wrapped ? (
    <Card style={{ padding: 0 }}>{listMarkup}</Card>
  ) : (
    listMarkup
  );
};

SelectablePaymentMethodButtonList.Button = Button;
